<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{ $t("credits.newCashbackCession") }}
      </p>
    </header>

    <section class="modal-card-body">
      <credit-form :stores="stores" @get-credits="$emit('get-credits')" />
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.cancel") }}
      </button>
    </footer>
  </div>
</template>

<script>
import creditForm from "./CreditForm";

export default {
  props: ["stores"],

  components: {
    creditForm
  }
};
</script>
